export interface IncidentCriteria {
  startDate?: Date | null;
  endDate?: Date | null;
  startIncidentDate?: Date | null;
  endIncidentDate?: Date | null;
  departure?: string;
  arrival?: string;
  employeeId?: string;
  appVersion?: string;
  flightNumber?: string;
  state?: string;
  formType?: string;
  sortField?: string;
  linkColumbus?: string;
  comment?: string;
  idEmployeeAnswered?: string;
  categorization?: string;
  sortOrder?: 'asc' | 'desc';
}

export type MapIncidentFiltersToCriteria = (
  filters: IncidentFilters,
  base: IncidentCriteria,
) => IncidentCriteria;

export interface IncidentFilters {
  startDate: Date | null;
  endDate: Date | null;
  startIncidentDate?: Date | null;
  endIncidentDate?: Date | null;
  departure?: string;
  arrival?: string;
  employeeId?: string;
  appVersion?: string;
  state?: string;
  description?: string;
  idEmployeeAnswered?: string;
}

export const emptyIncidentCriteria: IncidentCriteria = {};

export interface Incident {
  id: string;
  incidentDate: string;
  flightNumber: string;
  appVersion: string;
  employeeId: string;
  departure: string;
  arrival: string;
  state: string;
  employeeName: string;
  employeeRole: string;
  employeeEmail: string;
  employeeFleet: string;
  category: string;
  type: string;
  comment: string;
  incidentImage: string;
  incidentImageKey: string;
  flightMat: string;
  flightDate: string;
  flightFleet: string;
  iosVersion: string;
  linkColumbus: string;
  incidentColumbusNumber: string;
  idEmployeeAnswered: string;
  fullNameAnswered?: string;
  dateAnswered?: string;
  categorization?: string;
  message: string;
}

export const IncidentStatus = {
  NUEVO: { id: 1, label: 'Nuevo' },
  EN_CURSO: { id: 2, label: 'En curso' },
  EN_ESPERA: { id: 3, label: 'En espera' },
  RESUELTO: { id: 6, label: 'Resuelto' },
  CERRADO: { id: 7, label: 'Cerrado' },
  CANCELADO: { id: 8, label: 'Cancelado' },
} as const;

export type IncidentStatusKey = keyof typeof IncidentStatus;
